// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.selectAgentContainer_CRqiX {
  display: flex;
  flex-direction: column;
  width: 95%;
  margin: 0px 10px 10px;
  background: var(--f9-background);
  padding: 0px auto 10px;
  border-radius: 10px;

  .agentInfo_bqoEq {
    cursor: pointer;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 5px;
    min-width: 70%;
    white-space: nowrap;
    text-overflow: ellipsis;
    padding: 8px;

    &:hover {
      background-color: var(--f5-background);
    }
  }

  .leftSideSelectAgent_s658e {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .selectAgent_pqUhd {
    display: flex;
    flex-direction: column;
    gap: 10px;
    max-height: 30vh;
    overflow-y: auto;
    overflow-x: hidden;

    p {
      margin: 0;
      display: flex;
      flex-direction: column;

    }

    span {
      font-weight: 600;
      margin: 0;
      font-size: 10px;
      color: var(--_8a-color);
      padding: 0px 0;
      text-align: center;
    }
  }

  img {
    width: 26px;
    height: 26px;
    border-radius: 999px;
    -webkit-border-radius: 999px;
    -moz-border-radius: 999px;
    -ms-border-radius: 999px;
    -o-border-radius: 999px;
  }
}
.searchIconsWrappers_r3j4J {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  background: var(--ececf1-background);
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  border-radius: 3px;
}

.headerFilter_KZeDZ{
  display: flex
;
    flex-direction: column;
    padding: 8px 16px;
    gap: 10px;
}`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/screens/ChatView/SelectAgentModal/SelectAgentModal.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,qBAAqB;EACrB,gCAAgC;EAChC,sBAAsB;EACtB,mBAAmB;;EAEnB;IACE,eAAe;IACf,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,QAAQ;IACR,cAAc;IACd,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;;IAEZ;MACE,sCAAsC;IACxC;EACF;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;;IAElB;MACE,SAAS;MACT,aAAa;MACb,sBAAsB;;IAExB;;IAEA;MACE,gBAAgB;MAChB,SAAS;MACT,eAAe;MACf,uBAAuB;MACvB,cAAc;MACd,kBAAkB;IACpB;EACF;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,4BAA4B;IAC5B,yBAAyB;IACzB,wBAAwB;IACxB,uBAAuB;EACzB;AACF;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE;AACF;IACI,sBAAsB;IACtB,iBAAiB;IACjB,SAAS;AACb","sourcesContent":[".selectAgentContainer {\n  display: flex;\n  flex-direction: column;\n  width: 95%;\n  margin: 0px 10px 10px;\n  background: var(--f9-background);\n  padding: 0px auto 10px;\n  border-radius: 10px;\n\n  .agentInfo {\n    cursor: pointer;\n    border-radius: 8px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 5px;\n    min-width: 70%;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    padding: 8px;\n\n    &:hover {\n      background-color: var(--f5-background);\n    }\n  }\n\n  .leftSideSelectAgent {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n  }\n\n  .selectAgent {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    max-height: 30vh;\n    overflow-y: auto;\n    overflow-x: hidden;\n\n    p {\n      margin: 0;\n      display: flex;\n      flex-direction: column;\n\n    }\n\n    span {\n      font-weight: 600;\n      margin: 0;\n      font-size: 10px;\n      color: var(--_8a-color);\n      padding: 0px 0;\n      text-align: center;\n    }\n  }\n\n  img {\n    width: 26px;\n    height: 26px;\n    border-radius: 999px;\n    -webkit-border-radius: 999px;\n    -moz-border-radius: 999px;\n    -ms-border-radius: 999px;\n    -o-border-radius: 999px;\n  }\n}\n.searchIconsWrappers {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 18px;\n  height: 18px;\n  background: var(--ececf1-background);\n  cursor: pointer;\n  user-select: none;\n  border-radius: 3px;\n}\n\n.headerFilter{\n  display: flex\n;\n    flex-direction: column;\n    padding: 8px 16px;\n    gap: 10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"selectAgentContainer": `selectAgentContainer_CRqiX`,
	"agentInfo": `agentInfo_bqoEq`,
	"leftSideSelectAgent": `leftSideSelectAgent_s658e`,
	"selectAgent": `selectAgent_pqUhd`,
	"searchIconsWrappers": `searchIconsWrappers_r3j4J`,
	"headerFilter": `headerFilter_KZeDZ`
};
export default ___CSS_LOADER_EXPORT___;
